module.exports = __webpack_public_path__ + "img/46.c90c033b.png";